import(/* webpackMode: "eager" */ "/home/jihad/Torongo-Gadgets/torongo-frontend/src/app/page.tsx");
